import React from 'react';

type Props = {
  fill?: string;
};

const HelpIcon: React.FC<Props> = ({ fill }) => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.06683 5.36683C9.06683 4.90461 8.66238 4.50016 8.20016 4.50016C7.73794 4.50016 7.3335 4.90461 7.3335 5.36683C7.3335 5.82905 7.68016 6.2335 8.20016 6.2335C8.72016 6.2335 9.06683 5.82905 9.06683 5.36683ZM7.22238 11.8335H9.44461C9.77794 11.8335 10.0002 11.6762 10.0002 11.3616C10.0002 11.047 9.77794 10.8372 9.44461 10.8372H9.00016C8.94461 10.8372 8.88905 10.7848 8.88905 10.7324V8.21552C8.88905 7.63874 8.38905 7.16683 7.77794 7.16683H7.22238C6.88905 7.16683 6.66683 7.37657 6.66683 7.69117C6.66683 8.00578 6.88905 8.21552 7.22238 8.21552H7.66683C7.72238 8.21552 7.77794 8.26795 7.77794 8.32039V10.6799C7.77794 10.7324 7.72238 10.7848 7.66683 10.7848H7.22238C6.88905 10.7848 6.66683 10.9945 6.66683 11.3092C6.66683 11.6238 6.88905 11.8335 7.22238 11.8335ZM8.00016 1.8335C4.3335 1.8335 1.3335 4.8335 1.3335 8.50016C1.3335 12.1668 4.3335 15.1668 8.00016 15.1668C11.6668 15.1668 14.6668 12.1668 14.6668 8.50016C14.6668 4.8335 11.6668 1.8335 8.00016 1.8335Z"
      fill={fill || '#F04438'}
    />
  </svg>
);

export default HelpIcon;
